<div id="mi-attachments" class="mi-attachments" tabindex="-1" miFocusOnTab>
    @if (this.formisForm.fields.length> 0) {
    <div id="mi-attachments-content" class="container">
        <div class="row justify-content-center">

            <div class="col-12 mi-panel-wrraper standart">
                <div class="mi-panel-content">
                    <div class="mc-my-3">
                        <span class="mi-header">{{tabsText().attachments}}</span>

                    </div>

                    <div class="mi-white-panel with-shadow">

                        <div class="mi-back ">
                            <mc-button [label]="genericText()?.back" [ariaLabel]="genericText()?.back"
                                [icon]="'pi pi-fw pi-chevron-right'" class="mi-button-with-icon-primary"
                                id="mi-attachments-back" (click)="back()" (keyup.enter)="back()"></mc-button>
                        </div>

                        @if(isNoRelevantattachments){
                        <div class="mc-p-4 flex-column align-items-center text-center">
                            <div class="d-flex align-items-center  justify-content-center"> <img class="mc-p-3"
                                    src="assets/images/components/features/request/attachments/no-attachment.svg"
                                    alt="my import"></div>
                            <p class="bold-big-alert"> {{attachmentsText().isNoRelevantattachments}}</p>
                        </div>
                        }
                        @else{
                        <mc-field-form [formisForm]="formisForm">
                        </mc-field-form>

                        }

                    </div>
                </div>
                @if(isNewRequest || isExistDeclaration){
                <div class="row justify-content-center  justify-content-md-start ">
                    <div class=" mi-next blue-button col-md-3 col-12">
                        <mc-button [label]="getNextLabel()" [ariaLabel]="getNextLabel()" (click)="next()"
                            [id]="'mi-attachments-next-or-sent'"></mc-button>
                    </div>

                </div>
                }
            </div>
        </div>


    </div>
    }
    @else{
    <div id="mi-attachments-loaded">
        <mi-genral-skeleton></mi-genral-skeleton>
    </div>
    }

    <mc-dialog [dialogProperties]="dialogProperties">
        <mi-send-dialog [unionReqiestId]="unionReqiestId" [isSuccessSend]="isSuccessSend"></mi-send-dialog>
    </mc-dialog>

</div>